import React from 'react';
const IconRatingVeryHappyAlt = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 9.75C8.4665 9.75 9.25 8.9665 9.25 8C9.25 7.0335 8.4665 6.25 7.5 6.25C6.5335 6.25 5.75 7.0335 5.75 8C5.75 8.9665 6.5335 9.75 7.5 9.75Z" fill="#2D2E2E"/>
<path d="M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z" fill="#2D2E2E"/>
<path d="M5.68018 13C6.36018 15.87 8.93018 18 12.0002 18C15.0702 18 17.6402 15.87 18.3202 13H5.68018Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconRatingVeryHappyAlt;